import React, { useState, useEffect, Fragment } from 'react';

import { Card, CardBody, CardTitle, Button, Row, Col } from 'reactstrap';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

const OrderInfo = ({
  data,
  loadOrderVoucherpdf,
  loadMoreItems,
}) => {
  const [items, setItems] = useState(data);
  const [itemsNum, setItemsNum] = useState(items || null);
  const [loading, setLoading] = useState(false);

  // const [bookingDetails,setBookingDetails]=useState();
  useEffect(() => {
    setItems(data);
  }, [data]);


  const [showButton, setShowButton] = useState(false);
  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop - 10 <= e.target.clientHeight;
    if (bottom && items.length > 0) {
      setShowButton(true);
    }
  };
  return (
    <Fragment>
      {data !== undefined &&
        <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-4">
          <Card
            className="cardHeight"
            style={{ overflow: 'scroll' }}
            onScroll={handleScroll}
          >
            <CardBody>
              <div className="scroll">
                <Row className="mb-2">
                  <div className='col-md-12 orderInfo-name'>
                    {data.isCard !== undefined && data.isCard===true? <Fragment>
                      <b>{data.name}</b><span className='ml-1'>(Balance : {data.currency.toUpperCase()}<b>{parseFloat(data.balance,2)}</b>)</span>
                    </Fragment>
                      :  
                      <b>{data.name}</b>
                      } 
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className='col-md-12'>
                      <a href='#' className='vouchers-pdf' onClick={()=> loadOrderVoucherpdf(data.voucherNumber)}>View voucher PDF</a>
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className='col-md-12 details-heading'>
                    <strong> Voucher Number:</strong>
                  </div>
                  <div className='col-md-12'>
                    <span className=' details-subHeading'>{data.voucherNumber}</span>
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className='col-md-12 details-heading'>
                    <strong> Order Number:</strong>
                  </div>
                  <div className='col-md-12'>
                    <span className=' details-subHeading'>{data.orderNumber}</span>
                  </div>
                </Row>

                <Row className="mb-2">
                  <div className='col-md-12 details-heading'>
                    <strong> Sales Channel:</strong>
                  </div>
                  <div className='col-md-12'>
                    <span className=' details-subHeading'>{data.intregationName}</span>
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className='col-md-12 details-heading'>
                    <strong>Customer Email:</strong>
                  </div>
                  <div className='col-md-12'>
                    <span className=' details-subHeading'>{data.email}</span>
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className='col-md-12 details-heading'>
                    <b>Payment Reference:</b>
                  </div>
                  <div className='col-md-12'>
                    <span className=' details-subHeading' style={{textTransform:'capitalize'}}>{data.paymentid} {data.paymentMethod !== '' ?"("+data.paymentMethod+")" : ""}</span>
                  </div>
                  {data.comments !== undefined && 
                  <Fragment>                 
                 <div className='col-md-12'>
                   <span className=' details-subHeading'>{data.comments}</span>
                 </div>
                 </Fragment>
                  }
                </Row>
                <Row className="mb-2">
                  <div className='col-md-12 details-heading'>
                    <b>Payment Status:</b>
                  </div>
                  <div className='col-md-12'>
                    <span className=' details-subHeading' style={{color:'green'}}>{data.status}</span>
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className='col-md-4'>
                    <Row>
                      <div className='col-md-12 details-heading'>
                        <strong>Retail Price:</strong>
                      </div>
                      <div className='col-md-12'>
                        <span className=' details-subHeading'>{data.currency.toUpperCase()} {data.isCard !== undefined && data.isCard===true ? (data.discountedPrice - (data.discountedPrice * data.discount)/100) : data.price}</span>
                      </div>
                    </Row>
                  </div>
                  <div className='col-md-4'>
                    <Row>
                      <div className='col-md-12 details-heading'>
                        <strong>Discount:</strong>
                      </div>
                      <div className='col-md-12 text-left ml-4'>
                        <span className=' details-subHeading'> {data.discount}%</span>
                      </div>
                    </Row>
                  </div>
                  <div className='col-md-4'>
                    <Row>
                      <div className='col-md-12 details-heading'>
                        <strong>Price:</strong>
                      </div>
                      <div className='col-md-12'>
                        <span className=' details-subHeading'>{data.currency.toUpperCase()} {data.intregationName ==='aiva Dashboard'?parseFloat(parseFloat(data.discount) >0 ? (parseFloat(data.price)-(parseFloat(data.price)*parseFloat(data.discount))/100):data.price).toFixed(2) : data.discountedPrice}</span>
                      </div>
                    </Row>
                  </div>
                </Row>
                <Row className="mb-2">
                  <div className='col-md-12 details-heading'>
                    <strong>Voucher Status:</strong>
                  </div>
                  <div className='col-md-12'>
                    <span className=' details-subHeading' style={{color:`${data.redeem === 'NotRedeemed' ? 'green' : 'red'}`}}>{data.redeem === 'NotRedeemed' ? 'Available' : data.redeem}</span>
                  </div>
                </Row>
                {/* {data.voucherBookingDetails !== undefined && data.voucherBookingDetails.firstName !== null && data.voucherBookingDetails.firstName !== '' &&
                  <Row className="mb-2">
                    <div className='col-md-12 details-heading'>
                      <strong>Booking Details:</strong>
                    </div>
                    <div className='col-md-12'>
                      <span className='mr-2 mb-1 details-heading'>Name:</span><span className='details-subHeading'>{data.voucherBookingDetails.firstName +' '+data.voucherBookingDetails.lastName }</span>
                    </div>             
                    <div className='col-md-12'>
                      <span className='mr-2 mb-1 details-heading'>Address:</span><span className='details-subHeading'>{data.voucherBookingDetails.address }</span>
                    </div>
                    <div className='col-md-12'>
                      <span className='mr-2 mb-1 details-heading'>Country:</span><span className='details-subHeading'>{data.voucherBookingDetails.country}</span>
                    </div>
                    <div className='col-md-12'>
                      <span className='mr-2 mb-1 details-heading'>Phone Number:</span><span className='details-subHeading'>{data.voucherBookingDetails.phoneNumber}</span>
                    </div>
                  </Row>
                } */}
                {data.reportingTags !== undefined && data.reportingTags !== null && data.reportingTags.length > 0 && <Row className="mb-2">
                  <div className='col-md-12 details-heading'>
                    <strong>Reporting Tags:</strong>
                  </div>
                  <div className='col-md-12'>
                    <div className='row'>
                      {data.reportingTags !== undefined && data.reportingTags !== null && data.reportingTags.length > 0 && data.reportingTags.map((m) => (
                        <Button color="primary" style={{cursor:''}} className="ml-2 my-2" onClick={() => null}>
                          {m}
                        </Button>
                      ))}
                    </div>
                  </div>
                </Row>}
                {data.giftDetails !==null && data.giftDetails.to !== null &&
                  <Row className="mb-2">
                    <div className='col-md-12 details-heading'>
                      <strong>Gift Details:</strong>
                    </div>
                    <div className='col-md-12'>
                      <span className='mr-2 mb-1 details-heading'>Name:</span><span className='details-subHeading'>{data.giftDetails !== null ? data.giftDetails.to : ""}</span>
                    </div>
                    <div className='col-md-12'>
                      <span className='mr-2 mb-1 details-heading'>Email:</span><span className='details-subHeading'>{data.giftDetails !== null ? data.giftDetails.email : ""}</span>
                    </div>
                    <div className='col-md-12'>
                      <span className='mr-2 mb-1 details-heading'>Message:</span><span className='details-subHeading'>{data.giftDetails !== null ? data.giftDetails.message : ""}</span>
                    </div>
                    <div className='col-md-12'>
                      <span className='mr-2 mb-1 details-heading'>Date:</span><span className='details-subHeading'>{data.giftDetails !== null ? data.giftDetails.deliveryDate : ""}</span>
                    </div>
                    <div className='col-md-12'>
                      <span className='mr-2 mb-1 details-heading'>Status:</span><span className='details-subHeading'>{data.gifted ? "Email Sent" : "Email Pending"}</span>
                    </div>
                  </Row>}


                <Row className="mb-2">
                  <div className='col-md-4'>
                    <Row>
                      <div className='col-md-12 details-heading'>
                        <div className='d-flex'><strong>aiva</strong></div>
                        <div className='d-flex'><strong>Commission:</strong></div>
                      </div>
                      <div className='col-md-12'>
                        <span className=' details-subHeading'>{data.currency.toUpperCase()} {data.processingFee} ({parseFloat(data.aivaFeePercentage).toFixed(2)}%)</span>
                      </div>
                    </Row>
                  </div>
                  {data.thirdPartyProcessingFee !== 0 && 
                  <div className='col-md-4'>
                    <Row>
                      <div className='col-md-12 details-heading'>
                        <div className='d-flex'><strong>3rd Party</strong></div>
                        <div className='d-flex'><strong>Commission:</strong></div>
                      </div>
                      <div className='col-md-12'>
                        <span className=' details-subHeading'>{data.currency.toUpperCase()} {data.thirdPartyProcessingFee} ({parseFloat(data.thirdPartyFeePercentage).toFixed(2)}%)</span>
                      </div>
                    </Row>
                  </div>}
                  <div className='col-md-4'>
                    <Row>
                      <div className='col-md-12 details-heading'>
                        <div className='d-flex'><strong>Net</strong></div>
                        <div className='d-flex'><strong>Amount:</strong></div>
                      </div>
                      <div className='col-md-12'>
                        <span className=' details-subHeading'>{data.currency.toUpperCase()} {( data.isCard === true ? parseFloat(data.price) : parseFloat(data.discountedPrice)) - (parseFloat(data.processingFee) + parseFloat(data.thirdPartyProcessingFee))}</span>
                      </div>
                    </Row>
                  </div>
                </Row>
              </div>
            </CardBody>
          </Card>
        </Colxx>
      }
    </Fragment>
  );
};

export default OrderInfo;
